const moment = require('moment')

export default {
  data() {
    return {
      loadingCustomer: false
    }
  },
  computed: {
    customer: {
      get() {
        return this.$customer.customer
      },
      set(value) {
        this.$customer.customer = value
      }
    },
    customerId: {
      get() {
        return this.hasCustomer ? this.$customer.customer.customerId : 0
      }
    },
    customerData: {
      get() {
        return this.$customer.customerData
      },
      set(value) {
        this.$customer.customerData = value
      }
    },
    customerImage: {
      get() {
        return this.$customer.customerImage
      },
      set(value) {
        this.$customer.customerImage = value
      }
    },
    hasCustomer: {
      get() {
        return !!this.customer && Object.keys(this.customer).length !== 0
        // return !!this.customer && Object.keys(this.customer).length !== 0 && this.hasGdprStates
      }
    },
    customerImageUrl: {
      get() {
        return !!this.customerImage && this.customerImage.url ? this.customerImage.url : null
      }
    },
    hasAgreement: {
      get() {
        return this.hasCustomer && this.customer.allowsToUseCustomerApp === true
      }
    },
    hasGdprStates: {
      get() {
        return !!this.customerData.gdprStates && Object.keys(this.customerData.gdprStates).length !== 0
      }
    },
    hasLastLogin: {
      get() {
        return this.hasCustomer && !this.customer.lastLoginDate
      }
    },
    lastLoginDate: {
      get() {
        return this.hasCustomer && this.customer.lastLoginDate
      }
    },
    lastBooking: {
      get() {
        return this.hasCustomer && this.hasReservations ? this.customerData.reservations.find(r => r.reservationId === this.customer.lastBookingId) : null
      }
    },
    lastOrder: {
      get() {
        return this.hasCustomer && this.hasOrders ? this.customerData.orders.find(r => r.basketId === this.customer.lastBasketId) : null
      }
    },
    addressName: {
      get() {
        var array = []
        if (this.customer.firstName) {
          array.push(this.customer.firstName)
        }
        if (this.customer.lastName) {
          array.push(this.customer.lastName)
        }
        return array.join(' ')
      }
    },
    addressFullName: {
      get() {
        var array = []
        const c1 = this.composedTitles(this.customer.frontTitles)
        const c2 = this.customer.firstName ? this.customer.firstName : null
        const c3 = this.customer.lastName ? this.customer.lastName : null
        const c4 = this.composedTitles(this.customer.afterTitles)
        if (c1 !== null && c1 !== '') {
          array.push(c1)
        }
        if (c2 !== null && c2 !== '') {
          array.push(c2)
        }
        if (c3 !== null && c3 !== '') {
          array.push(c3)
        }
        if (c4 !== null && c4 !== '') {
          array.push(c4)
        }
        return array.join(' ')
      }
    },
    contactAddress: {
      get() {
        if (!!this.customer.contactAddress && !this.customer.contactAddress.addressName) {
          this.customer.contactAddress.addressName = this.addressName
        }
        return this.customer.contactAddress ? this.customer.contactAddress : {}
      }
    },
    invoiceAddress: {
      get() {
        if (!!this.customer.invoiceAddress && !this.customer.invoiceAddress.addressName) {
          this.customer.invoiceAddress.addressName = this.addressName
        }
        return this.customer.invoiceAddress ? this.customer.invoiceAddress : {}
      },
      set(value) {
        this.customer.invoiceAddress = value
      }
    },
    composedContactAddress: {
      get() {
        var array = []
        const c1 = this.contactAddress.street ? this.contactAddress.street : null
        const c2 = this.contactAddress.streetNo ? this.contactAddress.streetNo : null
        const c3 = this.contactAddress.zipCode ? this.contactAddress.zipCode : null
        const c4 = this.contactAddress.postSite ? this.contactAddress.postSite : null
        if (c1 !== null || c1 !== '') {
          array.push(c1)
        }
        if (c2 !== null || c2 !== '') {
          array.push(c2)
        }
        if (c3 !== null || c3 !== '') {
          array.push(c3)
        }
        if (c4 !== null || c4 !== '') {
          array.push(c4)
        }
        return array.join(' ')
      }
    },
    hasVisits: {
      get() {
        return this.customerData.visits && this.customerData.visits.length > 0
      }
    },
    hasOrders: {
      get() {
        return this.customerData.orders && this.customerData.orders.length > 0
      }
    },
    hasCharges: {
      get() {
        return this.customerData.charges && this.customerData.charges.length > 0
      }
    },
    validCards: {
      get() {
        return this.hasCards ? this.customerData.cards.filter(c => c.isOneTimeCard === false && moment(c.validTo).diff(moment()) > 0) : []
      }
    },
    hasValidCards: {
      get() {
        return this.validCards.length > 0
      }
    },
    hasCards: {
      get() {
        return this.customerData.cards && this.customerData.cards.length > 0
      }
    },
    hasReservations: {
      get() {
        return this.customerData.reservations && this.customerData.reservations.length > 0
      }
    },
    hasDocuments: {
      get() {
        return this.customerData.documents && this.customerData.documents.length > 0
      }
    },
    customerEmail: {
      get() {
        return this.customer.workingEMail || this.customer.eMail
      }
    },
    customerPhoneNo: {
      get() {
        return this.customer.workingPhoneNo || this.customer.phoneNo
      }
    }
    // contactChannels() {
    //   return !!this.customer.contactChannels ? this.customer.contactChannels : []
    // },
    // invoiceAddress() {
    //   return !!this.customer.invoiceAddress ? this.customer.invoiceAddress : {}
    //   //return this.customer.customer.invoiceAddress !== null && this.customer.customer.invoiceAddress !== undefined ? this.customer.customer.invoiceAddress : {}
    // },
    // deliveryAddress() {
    //   return !!this.customer.contactAddress ? this.customer.contactAddress : {}
    //   //return this.customer.customer.contactAddress !== null && this.customer.customer.contactAddress !== undefined ? this.customer.customer.contactAddress : {}
    // },
    // deliveryContact() {
    //   return {
    //     frontTitles: this.customer.frontTitles,
    //     firstName: this.customer.firstName,
    //     lastName: this.customer.lastName,
    //     afterTitles: this.customer.afterTitles,
    //     email: this.customer.eMail,
    //     phone: this.customer.phoneNo,
    //     company: ''
    //   }
    // },
    // invoiceContact() {
    //   return {
    //     frontTitles: this.customer.frontTitles,
    //     firstName: this.customer.firstName,
    //     lastName: this.customer.lastName,
    //     afterTitles: this.customer.afterTitles,
    //     email: this.customer.workingEMail,
    //     phone: this.customer.workingPhoneNo,
    //     company: ''
    //   }
    // }
  },
  methods: {
    validCard(cardId) {
      return this.validCards.find(c => c.cardId === cardId)
    },
    displayedCardNo(cardId) {
      const c = this.validCards.find(c => c.cardId === cardId)
      return c ? c.displayedCardNo : ''
    },
    composedTitles(value) {
      return value ? value.map(n => n.title).join(', ') : null
      // return value !== undefined && value !== null ? value.map(n => n.title).join(', ') : null
    },
    getCustomer() {
      return this.$customer.customer
    },
    setCustomer(value) {
      this.$customer.customer = value
    },
    fetchCustomer() {
      return this.$oauth2.$fetch('customers/myself').then(data => {
        this.setCustomer(data)
        this.fetchCustomerImage()
      }).catch(console.log)
    },
    fetchCards(from, to) {
      const path = 'customers/myself/cards?inactive=true&credited=true' + (from ? '&from=' + from : '') + (to ? '&to=' + to : '')
      return this.$oauth2.$fetch(path).then(data => {
        this.customerData.cards = data.sort((a, b) => {
          return new Date(b.validTo) - new Date(a.validTo)
        })
      }).catch(console.log)
    },
    fetchVisits(from, to) {
      const path = 'customers/myself/visits?credited=true' + (from ? '&from=' + from : '') + (to ? '&to=' + to : '')
      return this.$oauth2.$fetch(path).then(data => {
        this.customerData.visits = data.sort((a, b) => {
          return new Date(b.startTime) - new Date(a.startTime)
        })
        this.customerData.visits.filter(v => !v.card).forEach(v => {
          this.customerData.cards.filter(c => c.cardId === v.cardId).forEach(c => {
            v.set('card', c)
          })
        })
      }).catch(console.log)
    },
    fetchCharges(from, to) {
      const path = 'customers/myself/charges' + (from ? '&from=' + from : '') + (to ? '&to=' + to : '')
      return this.$oauth2.$fetch(path).then(data => {
        this.customerData.charges = data
      }).catch(console.log)
    },
    fetchDocuments(from, to) {
      const path = 'customers/myself/documents' + (from ? '&from=' + from : '') + (to ? '&to=' + to : '')
      return this.$oauth2.$fetch(path).then(data => {
        this.customerData.documents = data.sort((a, b) => {
          return new Date(b.file.date) - new Date(a.file.date)
        })
      }).catch(console.log)
    },
    fetchReservations(from, to) {
      const path = 'customers/myself/reservation-bookings' + (from ? '&from=' + from : '') + (to ? '&to=' + to : '')
      return this.$oauth2.$fetch(path).then(data => {
        this.customerData.reservations = data.sort((a, b) => {
          return new Date(b.sample.validFrom) - new Date(a.sample.validFrom)
        })
      }).catch(console.log)
    },
    fetchOrders(from, to) {
      const path = 'customers/myself/orders' + (from ? '&from=' + from : '') + (to ? '&to=' + to : '')
      return this.$oauth2.$fetch(path).then(data => {
        this.customerData.orders = data.sort((a, b) => {
          return new Date(b.createTime) - new Date(a.createTime)
        })
      }).catch(console.log)
    },
    customerUrl() {
      return this.$OPTIONS.appURL + this.$OPTIONS.restApi + 'customers/myself'
    },
    fetchCustomerData() {
      this.fetchCards()
      this.fetchVisits()
      this.fetchCharges()
      this.fetchDocuments()
      this.fetchReservations()
      this.fetchOrders()
    },
    getGdprStates() {
      return this.$oauth2.$fetch('customers/myself/gdpr-states').then(data => {
        this.customerData.gdprStates = data
      }).catch(() => console.log('gdpr get error'))
    },
    setGdprStates(value) {
      return this.$oauth2.$fetch('customers/myself/gdpr-states', {
        method: 'POST',
        body: JSON.stringify(value)
      }).then(data => {
        this.customer = data
        if (!this.customer.allowsToUseCustomerApp) {
          this.router.push({
            name: 'home'
          })
        }
      }).catch(() => console.log('gdpr post error'))
    },
    fetchCustomerImage() {
      return this.$oauth2.$fetch('customers/myself/images').then(response => {
        if (response !== null) {
          const contentType = response.headers.get("content-type")
          response.body.getReader().read().then(({value}) => {
            const decoder = new TextDecoder('utf-8')
            this.customerImage.url = 'data:' + contentType + ',' + decoder.decode(value)
          })
        }
      }).catch(console.log)
    }
  }
}
